import { render, staticRenderFns } from "./SystemDetail.vue?vue&type=template&id=4a436c54&scoped=true&"
import script from "./SystemDetail.vue?vue&type=script&lang=js&"
export * from "./SystemDetail.vue?vue&type=script&lang=js&"
import style0 from "./SystemDetail.vue?vue&type=style&index=0&id=4a436c54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a436c54",
  null
  
)

export default component.exports